<template>

  <div class="centraliser filter-wrap">

    <div class="block search-block">
      <div class="search-panel">
        <form class="form wide-search-bar" v-on:submit.prevent>
          <h3 style="margin-bottom: 0.5rem">Find an {{printLevel}} subject</h3>
          <div class="group required">
            <input type="text" name="search" id="search" class="panel-search-input" placeholder="Find a subject" 
            :value="searchTerm"
            @input="updateFilter"
            >
          </div>

          <!-- <div class="filters" v-if="postgrad">
            <h5>Level of study:</h5>  
            <a v-for="(filter, i) in levelFilters" :key=i
               class="tag"
               href="javascript:;"
              @click="setLevel(filter)"
              >
              <span class="icon-check" v-if=" level.includes( filter ) "></span>
              {{filter}}
            </a>
          </div> -->
          
          <div v-if="searchTerm || level" class="clear-button">
            <a href="javascript:;" class="button danger-hover no-icon" @click="clearFilter"><span class="icon-cross" ></span>Clear </a>
          </div>
        </form>


      </div>
    </div>


    <!-- <div class="block promo-block">
        <div class="promo secondary">
          <a href="http://www.victoria.ac.nz/about/global-engagement">
            <h2>How study works</h2>
            <p>We seek to bring the world to Victoria and Victoria to the world. <b>Find out more…</b></p>
          </a>
        </div>
      </div> -->
      <div class="block" v-if="searchTerm">
      Results are based on keywords in the subject name. For more comprehensive results, <a :href='"https://www.wgtn.ac.nz/search?tab=subjects&q=" + searchTerm'>search '{{ searchTerm }}'</a> across our whole site instead.
      </div>
  </div>

</template>

<script>
export default {
  name: 'SearchFilter',
  props: ['searchTerm', 'postgrad', 'gradLevel'],
  components: {

  },
  computed: {
    printLevel () {
      return (this.gradLevel == 'ug') ? 'undergraduate' : 'postgraduate';
    }
  },
  data () {
    return {
      levelFilters: ['Certificate', 'Diploma', 'Honours', 'Master', 'Doctor'],
      level: ''
    }
  },
  methods: {
    updateFilter (e) {
      this.$emit('update:searchTerm', e.target.value)
    },
    clearFilter () {
      this.level = ''
      this.$emit('update:searchTerm', '')
      this.$emit('update:studyLevel', '')
    },
    setLevel (filter) {
      
      if (this.level == filter) {
        this.level = ''
        this.$emit('update:studyLevel', this.level)
      } else {
        this.level = filter
        this.$emit('update:studyLevel', this.level)
      }

    }
  }
}
</script>

<style lang="scss" scoped>
  // .filter-wrap {
  //   display: grid;
  //   grid-template-columns: repeat(3, 1fr);

  //   .search-block {
  //     grid-column: 1 / span 2;
  //   }

  //   .promo-block {
  //     grid-column: 3 / span 1;
  //   }

  //   @media  (max-width: 42.99em) {
  //     .search-block {
  //       grid-column: 1 / span 3;
  //       grid-row: 2;
  //     }

  //     .promo-block {
  //       grid-column: 1 / span 3;
  //       grid-row: 1;
  //     }
  //   }
  // }
  
  .filters {
    h5 {
      color: #424242;
      margin-bottom: .5rem;
      margin-top: 1rem;
    }
  }

  .tag {
  // margin-top: .5rem;
  margin-right: .5rem;
  // font-size: 1.2rem;
  // font-weight: 400;

    &:hover {
      span {
        &::before {
          content: "";
        }
      } 
    }
  }

  .clear-button {
    margin-top: 1rem;
  }
  .search-block {
    padding-bottom: 0 !important;
  }

</style>